import { availabilityStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsAvailability";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { COLORS, TYPOGRAPHY } from "@store/theme/design";
import merge from "lodash/merge";
import { css } from "styled-components";

// TODO: ISA REFACTOR
merge(availabilityStyles, {
    availability: {
        container: {
            css: css`
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                padding: 0 25px 0 0;
                                margin: 0;
                                display: inline-block;
                                width: auto;
                                line-height: 120%;
                            `,
                            css`
                                width: 60%;
                            `,
                            css`
                                border-bottom: 1px solid ${COLORS.border.base};
                                padding-bottom: 15px;
                                margin-bottom: 15px;
                                width: 100%;
                                display: block;
                            `,
                            css``,
                            css``,
                        ],
                        "min",
                    )}
            `,
        },
        messageGridItem: {
            css: css`
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css``,
                            css`
                                position: relative;
                                top: 7px;
                            `,
                            css``,
                            css``,
                            css``,
                        ],
                        "max",
                    )}
            `,
        },
        inventoryMessage: {
            css: css`
                /* margin-left: -8px;
                background: yellow;*/
            `,
        },
        messageText: {
            css: css`
                font-size: ${TYPOGRAPHY.size.larger} !important;
                margin-left: -8px;
                line-height: 110%;
            `,
        },
        availabilityByWarehouseTable: {
            css: css`
                background-color: #fff;
            `,
        },
    },
});
